import React from 'react';
import { Card, Row, Col, Breadcrumb, Divider, Popconfirm, Form, message } from 'antd';
import { onGet, onPost, api } from '../../../../core/api3';
import { getUrlParam } from '../../../../utils/commonUtils';
import QuantRobotLogCard from './QuantRobotLogCard';
import QuantRobotStrategyDataCard from './QuantRobotStrategyDataCard';
import QuantRobotStatusDataCard from './QuantRobotStatusDataCard';
import QuantRobotStrategyInteractionCard from './QuantRobotStrategyInteractionCard';

class QuantRobotDetailView extends React.Component {

    constructor() {
        super();
        this.state = {
            quantRobot: {}
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.loadData();
        this.dataPolling = setInterval(() => {
            this.loadData();
        }, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.dataPolling);
    }

    loadData() {
        let robotId = getUrlParam(this.props.location.search, 'robotId');
        onGet(api.getQuantRobot.url, api.getQuantRobot.params(robotId)).then(response => {
            if (response === undefined) {
                return;
            }
            let statusStr = ['未运行', '运行中', '停止中'];
            response.statusStr = statusStr[response.status];
            this.setState({ quantRobot: response });
        });
    }

    onClick(type) {
        switch (type) {
            case 'start':
                onPost(api.startRobot.url, api.startRobot.params(this.state.quantRobot.id)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('启动成功');
                    this.loadData();
                });
                break;
            case 'stop':
                onPost(api.stopRobot.url, api.stopRobot.params(this.state.quantRobot.id)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('停止成功');
                    this.loadData();
                });
                break;
            default:
                break;
        }
    }

    render() {
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a href="#/coin/quantRobot">量化实盘</a></Breadcrumb.Item>
                    <Breadcrumb.Item>量化实盘详情</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content2">
                    <Card title="基本信息" bordered={false} >
                        <Row>
                            <Col span="6" push="0">
                                实盘名称：{this.state.quantRobot.name}
                            </Col>
                            <Col span="6" push="0">
                                实盘策略：{this.state.quantRobot.strategyDescribe}
                            </Col>
                            <Col span="6" push="0">
                                实盘状态：<span style={this.state.quantRobot.status !== 0 ? { color: '#FF0000' } : {}}>{this.state.quantRobot.statusStr}</span>
                                <Divider type="vertical" hidden={this.state.quantRobot.status === 2} />
                                <Popconfirm title="确定要启动实盘？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('start')}>
                                    <a hidden={this.state.quantRobot.status !== 0}>启动</a>
                                </Popconfirm>
                                <Popconfirm title="确定要停止实盘？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('stop')}>
                                    <a hidden={this.state.quantRobot.status !== 1}>停止</a>
                                </Popconfirm>
                            </Col>
                            <Col span="6" push="0">
                                当前收益：{this.state.quantRobot.profit === undefined ? '0' : this.state.quantRobot.profit.toFixed(4)}
                            </Col>
                        </Row>
                        <Row className="box-row">
                            <Col span="6" push="0">
                                添加时间：{this.state.quantRobot.createTime}
                            </Col>
                            <Col span="6" push="0">
                                最后运行时间：{this.state.quantRobot.lastRunTime === undefined ? '还未运行过' : this.state.quantRobot.lastRunTime}
                            </Col>
                        </Row>
                    </Card>
                </div>
                <div className="content2">
                    {this.state.quantRobot.statusData &&
                        <QuantRobotStatusDataCard statusData={JSON.parse(this.state.quantRobot.statusData)} location={this.props.location} />
                    }
                </div>
                <div className="content2">
                    {this.state.quantRobot.strategyData &&
                        <QuantRobotStrategyDataCard robotId={this.state.quantRobot.id} status={this.state.quantRobot.status} strategyData={JSON.parse(this.state.quantRobot.strategyData)} location={this.props.location} />
                    }
                </div>
                <div className="content2">
                    {this.state.quantRobot.strategyInteraction &&
                        <QuantRobotStrategyInteractionCard robotId={this.state.quantRobot.id} status={this.state.quantRobot.status} strategyInteraction={JSON.parse(this.state.quantRobot.strategyInteraction)} location={this.props.location} />
                    }
                </div>
                <div className="content2">
                    <QuantRobotLogCard robotId={getUrlParam(this.props.location.search, 'robotId')} location={this.props.location} />
                </div>
            </div>
        );
    }

}

const QuantRobotDetailPage = Form.create()(QuantRobotDetailView);
export default QuantRobotDetailPage;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotDetailPage.jsx